import { defineQuartzConfig } from 'quartz-config';
export default defineQuartzConfig({
  type: 'application',
  auth: 'none',
  htmlTitle: 'HubSpot Recording',
  htmlTitleLangKey: 'universal-recording-review-public-ui.app.htmlTitle',
  historyBasename: '/share',
  includeDefaultViewportMetaTag: true,
  createRootApi: 'tests-only'
});